export const COL_IDS = {
    title: 'title',
    baseForm: 'baseForm',
    reportType: 'reportType',
    createdDate: 'createdDate',
    userName: 'userName',
    updateTime: 'updateTime',
    isGeneral: 'isGeneral',
    isActive: 'isActive'
};

export const ITEMS_PER_PAGE = 20;
